import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import { AssetSummaryDto, AssetSummaryDtoV2, type MonitorSummaryDto } from '@/api';
import { useRouter } from 'vue-router/composables';
import MonitorPreviewCard from '../monitor-preview-card/Monitor-Preview-Card.vue';
import AssetPreviewCard from '../asset-preview-card/Asset-Preview-Card.vue';

interface EntityPreviewCardProps {
  entity: AssetSummaryDto | MonitorSummaryDto | AssetSummaryDtoV2;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Entity-Preview-Card',
  props: {
  entity: null
},
  setup(__props) {

const props = __props;


const router = useRouter();

const is = _computed(() => {
  switch (props.entity.displayedType) {
    case AssetSummaryDto.displayedType.MONITOR:
      return MonitorPreviewCard;
    default:
      return AssetPreviewCard;
  }
});
const routeName = _computed(() => {
  switch (props.entity.displayedType) {
    case AssetSummaryDto.displayedType.MONITOR:
      return 'monitors.rule.overview';
    default:
      return 'data-catalog.asset.overview';
  }
});
const params = _computed(() : any => {
  const routeParams: any = {};
  switch (props.entity.displayedType) {
    case AssetSummaryDto.displayedType.MONITOR:
      routeParams.id = props.entity.urn?.replace('sifflet-rule:', '')!;
      break;
    default:
      routeParams.urn = props.entity.urn!;
      break;
  }
  return routeParams;
});
const assetLink = _computed(() => ({ name: routeName.value, params: params.value }));

const openAsset = () => {
  router.push(assetLink.value);
};


return { __sfc: true,props, router, is, routeName, params, assetLink, openAsset, _computed, AssetSummaryDto, AssetSummaryDtoV2, useRouter, MonitorPreviewCard, AssetPreviewCard }
}

})